<template>
  <div
    v-on-clickaway="hideOptions"
    :class="wrapperCssClass"
    class="page-length-selector__wrapper selectbox"
    @click="toggleOptions"
  >
    <span class="page-length-selector__current-length">{{ currentPageLength }}</span>
    <ul
      v-show="showOptions"
      class="page-length-selector__selectbox"
    >
      <li
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :class="isActive(option.value)"
        class="page-length-selector__option"
        @click="emitChange(option.value)"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mixin as Clickaway } from 'vue-clickaway2';

export default {
  name: 'PageLengthSelector',
  mixins: [Clickaway],
  props: {
    currentPageLength: {
      type: Number,
      required: true,
    },
    pageLengths: {
      type: Array,
      default: () => [48, 98],
    },
    promotedOfferSpace: {
      type: Number,
      default: 0,
    },
  },
  emits: ['change'],
  data() {
    return {
      pageLength: this.currentPageLength,
      showOptions: false,
    };
  },
  computed: {
    options() {
      const { pageLengths } = this;
      return pageLengths.map((pageLength) => {
        const size = pageLength - this.promotedOfferSpace;
        return {
          value: size,
          label: size,
        };
      });
    },
    wrapperCssClass() {
      return this.showOptions ? 'page-length-selector__wrapper--active' : '';
    },
  },
  methods: {
    emitChange(pageLength) {
      this.$emit('change', pageLength);
    },
    hideOptions() {
      this.showOptions = false;
    },
    isActive(value) {
      return value === this.currentPageLength ? 'page-length-selector__option__active' : '';
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
@use 'sass:color';

.page-length-selector {
  &__option {
    padding: 6px 32px 6px 18px;

    &:hover,
    &__active {
      background-color: color.adjust(#ededed, $lightness: -30%);
    }
  }

  &__selectbox {
    position: absolute;
    list-style: none;
    left: -1px;
    right: -1px;
    top: 35px;
    background-color: #ededed;
    border: 1px solid #b2b2b2;
    border-radius: 0 0 4px 4px;
    border-top: 0;
    z-index: 3;
  }

  &__wrapper {
    padding: 0 30px 0 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    list-style: none;
    position: relative;
    width: 70px;
    border-bottom: 1px solid #b2b2b2;
    border-radius: 4px;

    &--active {
      background-image: url('data:image/png;base64,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');
      background-size: 12px;
      border-bottom-color: #ededed;
      border-radius: 4px 4px 0 0;
    }
  }
}
</style>
